import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import "@/design/index.scss";
import VueSweetalert2 from 'vue-sweetalert2';
import store from '@/state/store';
import _ from 'lodash'
import {ApiMixin} from "@/mixins/ApiMixin";
import { loadProgressBar } from 'axios-progress-bar'
import Axios from 'axios'
import App from './App.vue'
import Multiselect from 'vue-multiselect'
import VueDayjs from 'vue-dayjs-plugin'

Vue.prototype.$http = Axios;

if(store.getters.memberToken) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.memberToken
} else if (store.getters.token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.token
}
Vue.prototype.$http.defaults.headers.common['Accept'] = 'application/json'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(VueSweetalert2);
Vue.mixin(ApiMixin);
loadProgressBar();
Vue.prototype._ = _
Vue.component('multiselect', Multiselect)

// Vue Day JS
Vue.use(VueDayjs)
var relativeTime = require('dayjs/plugin/relativeTime')
Vue.dayjs.extend(relativeTime);

new Vue({
  router,
  store,
  data() {
    return {
      api_url: process.env.VUE_APP_API_URL,
    }
  },
  render: h => h(App),
}).$mount('#app');
